// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","continue":"Buttons_continue__kZRw1","back":"Buttons_back__pnXgE","navButtons":"Buttons_navButtons__KcMIB"};